import Vue from 'vue';
import VueI18n from 'vue-i18n';
import store from '@/store';
import enGB from '@/locales/en_GB.json'; // English (UK)
import enUS from '@/locales/en_US.json'; // English (US)
import ptPT from '@/locales/pt_PT.json'; // Portuguese (Portugal)
import nl from '@/locales/nl.json'; // Dutch
import fr from '@/locales/fr.json'; // French
import es from '@/locales/es.json'; // Spanish
import de from '@/locales/de.json'; // German

Vue.use(VueI18n);

const messages = {
  'en-GB': enGB,
  'en-US': enUS,
  'pt-PT': ptPT,
  nl,
  fr,
  es,
  de,
};

const dateTimeFormats = {
  'en-GB': {
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    },
    long: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric',
    },
  },
};

const numberFormats = {
  gbp: {
    currency: {
      style: 'currency', currency: 'GBP', currencyDisplay: 'symbol',
    },
  },
  eur: {
    currency: {
      style: 'currency', currency: 'EUR', currencyDisplay: 'symbol',
    },
  },
  usd: {
    currency: {
      style: 'currency', currency: 'USD', currencyDisplay: 'symbol',
    },
  },
};

const i18n = new VueI18n({
  locale: store.getters['user/user'] ? store.getters['user/user'].language : navigator.language,
  fallbackLocale: 'en-GB',
  dateTimeFormats,
  numberFormats,
  messages,
  sync: false,
});

export function t(...args) {
  return i18n.t(...args);
}

export function tc(...args) {
  return i18n.tc(...args);
}

export function te(...args) {
  return i18n.te(...args);
}

export function d(...args) {
  return i18n.d(...args);
}

export function n(...args) {
  return i18n.n(...args);
}

export default i18n;
